import Axios from "api/Axios";

// Add new dashboard
export const createDashboard = async (payload) => {
    const response = await Axios.post(`/create_dashboard/`, payload);
    return response.data;
}

// Get dashboard list
export const getDashboards = async () => {
    const response = await Axios.get(`/list_dashboards/`);
    return response.data;
}

// Add chart to dashboard
export const addChartToDashboard = async (payload) => {
    const response = await Axios.post(`/add_chart_to_dashboard/`, payload);
    return response.data;
}

// Get dashboard chart list
export const getDashboardCharts = async (payload) => {
    const response = await Axios.get(`/list_charts/`, { params: payload });
    return response.data;
}

// Delete chart from dashboard
export const deleteChartFromDashboard = async (payload) => {
    const response = await Axios.delete(`/delete_chart/`, { params: payload });
    return response.data;
}

// Move chart from one dashboard to another
export const moveChartToDashboard = async (payload) => {
    const { chartid, old_dashid, new_dashid } = payload
    const response = await Axios.post(`/move_chart/`, null, {
        params: {
            chartid,
            old_dashid,
            new_dashid
        }
    });
    return response.data;
}


// New APIs per backend contract
// 1) Initial data + filterable flag
// GET /story/v1/dashboard_id/?chartid=2&dashboard_id=2
export const getDashboardChartInitial = async ({ chartid, dashboard_id }) => {
    const response = await Axios.get(`/dashboard_id/`, {
        params: { chartid, dashboard_id }
    });
    return response.data;
}

// 2) Filtered data (when filterable)
// GET /story/v1/dash_board_id/filtered?chartid=32&dashboard_id=38&start_date=2025-01-01&end_date=2025-12-31
export const getDashboardChartFiltered = async ({ chartid, dashboard_id, start_date, end_date }) => {
    const response = await Axios.get(`/dash_board_id/filtered`, {
        params: { chartid, dashboard_id, start_date, end_date }
    });
    return response.data;
}

